<template>
    <v-data-table
        class="elevation-0"
        :headers="headers"
        :items="tableItems"
        :items-per-page="15"
        :footer-props="dataTableFooterProps"
        :search="dataTableSearch"
        :custom-filter="dataTableCustomFilter"
        :loading="isBusy"
        :loading-text="$t('common.loading_table_data')"
        :expanded.sync="expanded"
        show-expand
    >
        <template v-slot:item.warehouse_count="{ item }">
            {{ item.warehouse_count }}
        </template>
        <template v-slot:top>
            <v-toolbar flat color="white">
                <v-text-field
                    v-model="dataTableSearch"
                    prepend-inner-icon="mdi-magnify"
                    :placeholder="$t('common.filter')"
                    outlined
                    dense
                    hide-details
                />
                <v-spacer/>
                <p class="mr-3 mt-2">
                    <v-icon>
                        {{ synchronizationIcon(synchronization) }}
                    </v-icon>
                    {{ synchronization ? $t('synchronization.status.' + synchronization.status) : '-' }}
                    ({{ synchronization ? $moment(synchronization.date_time).format('LLL') : '-' }})
                    <span v-if="synchronization && synchronization.status === 'error' && synchronization.error" class="error--text">
                        - {{ synchronization.error }}
                    </span>
                </p>
                <v-btn
                    v-if="!synchronization || (synchronization.status !== 'waiting' && synchronization.status !== 'synchronizing')"
                    color="success"
                    dark
                    class="mb-2"
                    @click="onSynchronize"
                    :loading="isBusySynchronize"
                >
                    {{ $t('button.synchronize') }}
                </v-btn>
            </v-toolbar>
        </template>
        <template v-slot:item.attributes_count="{ item }">
            {{ item.attributes_count }}
        </template>
        <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length" class="pa-3">
                {{ $t('product_types.product_type') }}:
                <b>{{ item.name }}</b>
                <br/>
                {{ $t('product_types.product_type_attributes') }}:<br/>
                <template v-if="item.attributes.length > 0">
                    <div class="ml-5"
                         v-for="(attribute, i) in item.attributes"
                         :key="i"
                    >
                        <v-row no-gutters>
                            <v-col>
                                {{ $t('product_types.product_type_attribute_key') }}:
                                <b>{{ attribute.key }}</b>
                            </v-col>
                            <v-col>
                                {{ $t('product_types.product_type_attribute_description') }}:
                                <b>{{ attribute.description ? attribute.description : '-' }}</b>
                            </v-col>
                        </v-row>
                        <v-divider/>
                    </div>
                </template>
                <template v-else>
                    <div class="ml-5">
                        <i>{{ $t('product_types.no_attributes') }}</i>
                    </div>
                </template>
            </td>
        </template>
    </v-data-table>
</template>
<script>
import SnackbarMixin from '@/mixins/SnackbarMixin'
import {API} from '@/api/api'
import SynchronizationMixin from "@/mixins/SynchronizationMixin";
import DataTableMixin from "@/mixins/DataTableMixin";

export default {
    name: 'ProductTypesTableComponent',
    mixins: [SnackbarMixin, SynchronizationMixin, DataTableMixin],
    data: () => ({
        // loading
        isBusyProductTypes: false,
        isBusySynchronize: false,
        isBusySynchronization: false,
        // table data
        items: [],
        // synchronization data
        synchronization: null,
        // expanded table row
        expanded: [],
    }),
    computed: {
        isBusy() {
            return this.isBusyProductTypes || this.isBusySynchronize || this.isBusySynchronization;
        },
        headers() {
            return [
                {
                    text: this.$t('product_types.name'),
                    value: 'name'
                },
                {
                    text: this.$t('product_types.attributes'),
                    value: 'attributes_count'
                },
                {
                    text: this.$t('brands.warehouses_count'),
                    value: 'warehouse_count'
                }
            ];
        },
        tableItems() {
            return this.items.map(productType => this.withDataTableSearch({
                ...productType,
                attributes_count: productType.attributes.length,
                warehouse_count: productType.warehouse_ids.length
            }, [
                productType.name,
                productType.attributes.map(attribute => [attribute.key, attribute.description]),
                productType.attributes.length,
                productType.warehouse_ids.length
            ]));
        }
    },
    methods: {
        fetchProductTypes() {
            this.isBusyProductTypes = true;
            API.get('/api/product-types')
                .then(response => {
                    this.items = response.data;
                })
                .catch(error => {
                    this.snackbarError(error);
                })
                .finally(() => {
                    this.isBusyProductTypes = false;
                });
        },
        fetchSynchronization() {
            this.isBusySynchronization = true;
            API.get('/api/synchronizations/product-type')
                .then(response => {
                    this.synchronization = response.data;
                })
                .catch(error => {
                    this.snackbarError(error);
                })
                .finally(() => {
                    this.isBusySynchronization = false;
                });
        },
        onSynchronize() {
            this.isBusySynchronize = true;
            API.post('/api/product-types/synchronize', [])
                .then(() => {
                    this.snackbarSuccess(this.$t('snackbar.product_type.synchronized'));
                    this.fetchProductTypes();
                    this.fetchSynchronization();
                })
                .catch(error => {
                    this.snackbarError(error);
                })
                .finally(() => {
                    this.isBusySynchronize = false;
                })
        }
    },
    created() {
        this.fetchProductTypes();
        this.fetchSynchronization();
    }
}
</script>
